import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  AzureDevOpsProject,
  AzureWiki,
  AzureWikiBatchImportRequest,
  AzureWikiImportRequest,
  AzureWikiPage
} from '../../../core/models/knowledge-azure-wiki.model';
import { ImportResultResponse, SyncResultResponse } from '../../../core/models/knowledge-import-result.model';

/**
 * Navegación e importación de Azure DevOps Wiki (RF-002/RF-004). El árbol
 * de páginas de una wiki llega completo en UNA llamada (recursionLevel=Full,
 * BR-33): la expansión/colapso es del componente, en memoria, sin peticiones
 * por nodo. `projectId` es siempre el proyecto GDB; `azureProject` es el
 * proyecto de Azure DevOps seleccionado en la navegación.
 */
@Injectable({
  providedIn: 'root'
})
export class AzureWikiService {

  private readonly baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = `${environment.knowledgeApiUrl}/knowledge/azure-wiki`;
  }

  listProjects(projectId: string): Observable<AzureDevOpsProject[]> {
    return this.http.get<AzureDevOpsProject[]>(`${this.baseUrl}/projects`, {
      params: { projectId }
    });
  }

  listWikis(projectId: string, azureProject: string): Observable<AzureWiki[]> {
    return this.http.get<AzureWiki[]>(`${this.baseUrl}/wikis`, {
      params: { projectId, azureProject }
    });
  }

  listPages(projectId: string, wikiId: string): Observable<AzureWikiPage[]> {
    return this.http.get<AzureWikiPage[]>(
      `${this.baseUrl}/wikis/${encodeURIComponent(wikiId)}/pages`,
      { params: { projectId } }
    );
  }

  importPage(request: AzureWikiImportRequest): Observable<ImportResultResponse> {
    return this.http.post<ImportResultResponse>(`${this.baseUrl}/import`, request);
  }

  importPagesBatch(request: AzureWikiBatchImportRequest): Observable<ImportResultResponse> {
    return this.http.post<ImportResultResponse>(`${this.baseUrl}/import/batch`, request);
  }

  synchronize(projectId: string): Observable<SyncResultResponse> {
    return this.http.post<SyncResultResponse>(`${this.baseUrl}/synchronize`, null, {
      params: { projectId }
    });
  }
}
